import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=20303225&scoped=true"
import script from "./Default.vue?vue&type=script&setup=true&lang=js"
export * from "./Default.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=20303225&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20303225",
  null
  
)

export default component.exports